<!--
목적 : 공정사고 컴포넌트 (단일/복수 선택 지원)
  - multiple = false : String (iimAccidentId 단일값)
  - multiple = true  : String (iimAccidentId를 콤마로 구분한 문자열)
-->
<template>
  <div class="fix-height">
    <q-field
      v-if="multiple"
      class="customAccident customTag"
      stack-label
      filled
      :dense="dense"
      color="orange-custom"
      :label="convertLabel"
      :disable="disabled||!editable"
      :rules="[myRule]"
      v-model="vValueList"
      >
      <template v-slot:label v-if="label">
        <div class="row items-center all-pointer-events">
          <b>
            <i v-if="!required" class="pe-7s-note labelfrontIcon searchAreaLabelIcon"></i>
            <font class="formLabelTitle">{{convertLabel}}</font>
            <i v-if="required" class="material-icons labelfrontIcon text-requiredColor">check</i>
          </b>
        </div>
      </template>
      <template v-slot:control>
        <q-chip
          v-for="(item, idx) in vValueList"
          :key="idx"
          outline square
          :dense="dense"
          :removable="editable&&!disabled"
          color="light-blue"
          :label="nameFor(item)"
          :title="nameFor(item)"
          @remove="removeItem(idx)"
          clickable
          class="all-pointer-events"
          @click="linkClick(item)"
        />
        <q-chip
          v-if="editable&&!disabled"
          :dense="dense"
          outline square
          clickable
          color="orange"
          text-color="white"
          icon="add"
          label="추가"
          @click="search"
        />
      </template>
    </q-field>
    <q-field
      v-else
      ref="customAccident"
      class="customAccident q-field--with-bottom"
      :dense="dense"
      stack-label
      filled
      color="orange-custom"
      :label="convertLabel"
      :disable="disabled||!editable"
      :rules="!required ? null : [val => !!val || '']"
      v-model="valueText"
      >
      <template v-slot:label v-if="label">
        <div class="row items-center all-pointer-events">
          <b>
            <i v-if="!required" class="pe-7s-note labelfrontIcon searchAreaLabelIcon"></i>
            <font class="formLabelTitle">{{convertLabel}}</font>
            <i v-if="required" class="material-icons labelfrontIcon text-requiredColor">check</i>
          </b>
        </div>
      </template>
      <template v-slot:control>
        {{valueText}}
      </template>

      <template v-slot:append>
        <q-icon v-if="!disabled&&editable" name="search" @click="search" class="cursor-pointer"></q-icon>
        <q-icon v-if="!disabled&&editable" name="close" @click="reset" class="cursor-pointer"></q-icon>
      </template>
    </q-field>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import mixinCommon from './js/mixin-common'
import selectConfig from '@/js/selectConfig';
export default {
  name: 'CAccident',
  mixins: [mixinCommon],
  props: {
    name: {
      type: String,
      default: 'field',
    },
    // multiple = false : String (iimAccidentId)
    // multiple = true  : String (iimAccidentId, 콤마 구분)
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '재해발생사례',
    },
    // 쓰기 권한 여부
    editable: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: 'edit', // search, edit
    },
    // 필수 입력 여부
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: true,
    },
    isNear: {
      type: Boolean,
      default: false,
    },
    // 복수 선택 여부
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      vValue: null,
      vValueList: [],
      idNameMap: {},
      valueText: '',
      detailUrl: '',
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        width: '50%',
        param: {},
        closeCallback: null,
      },
    };
  },
  computed: {
  },
  watch: {
    // todo : 부모의 v-model 변경을 감시
    value: {
      handler: function () {
        if (this.multiple) {
          this.vValueList = this.value ? this.value.split(',').map(v => v.trim()).filter(v => v) : [];
          this.fetchNames(this.vValueList);
        } else {
          this.vValue = this.value;
          this.setValueText();
        }
      },
      deep: true,
    },
  },
  /* Vue lifecycle: created, mounted, destroyed, etc */
  beforeMount() {
    this.detailUrl = selectConfig.sop.iim.accident.process.get.url;
    if (this.multiple) {
      this.vValueList = this.value ? this.value.split(',').map(v => v.trim()).filter(v => v) : [];
      this.fetchNames(this.vValueList);
    } else {
      this.vValue = this.value;
      this.setValueText();
    }
  },
  mounted() {
    if (!this.multiple && !this.disabled) {
      this.$refs['customAccident'].$el.getElementsByClassName('q-field__native')[0].addEventListener('click', this.search);
    }
  },
  beforeDestroy() {
    if (!this.multiple && !this.disabled) {
      this.$refs['customAccident'].$el.getElementsByClassName('q-field__native')[0].addEventListener('click', this.search);
    }
  },
  /* methods */
  methods: {
    /**
     * v-model로 받은 값을 통해 공정사고 정보 조회 (단일 선택 모드)
     */
    setValueText() {
      if (this.vValue) {
        this.$http.url = this.$format(this.detailUrl, this.vValue);
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          if (_result.data) {
            this.valueText = _result.data.accidentName;
          } else {
            this.valueText = '';
          }
        },);
      } else {
        this.valueText = '';
      }
    },
    search() {
      this.popupOptions.title =  this.isNear ? '아차사고 검색' : '공정사고 검색'; 
      this.popupOptions.param = {
        type: this.multiple ? 'multiple' : 'single',
        nearFlag: this.isNear ? 'Y' : 'N',
      };
      this.popupOptions.target = () => import(`${'@/pages/sop/iim/processAccidentPop.vue'}`);
      this.popupOptions.width = '90%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        if (this.multiple) {
          let list = this.$_.clone(this.vValueList);
          this.$_.forEach(data, (item) => {
            this.$set(this.idNameMap, item.iimAccidentId, item.accidentName);
            if (list.indexOf(item.iimAccidentId) === -1) {
              list.push(item.iimAccidentId);
            }
          });
          this.vValueList = list;
          this.$emit('input', list.join(','));
        } else {
          let beforeIimAccidentId = this.$_.clone(this.vValue);
          this.$emit('dataChange', data[0].iimAccidentId, beforeIimAccidentId, data[0]);
          this.$emit('accidentName', data[0].accidentName);
          this.$emit('input', data[0].iimAccidentId);
        }
      }
    },
    removeItem(idx) {
      let list = this.$_.clone(this.vValueList);
      list.splice(idx, 1);
      this.vValueList = list;
      this.$emit('input', list.join(','));
    },
    /**
     * 표시용 이름 조회 (캐시에 없으면 임시로 id 표시, fetchNames가 채워주면 반응형으로 갱신)
     */
    nameFor(id) {
      return this.idNameMap[id] || id;
    },
    fetchNames(ids) {
      this.$_.forEach(ids, (id) => {
        if (this.idNameMap[id]) return;
        this.$http.url = this.$format(this.detailUrl, id);
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          if (_result.data) {
            this.$set(this.idNameMap, id, _result.data.accidentName);
          }
        },);
      });
    },
    reset() {
      let beforeIimAccidentId = this.$_.clone(this.vValue);
      this.valueText = '';
      this.$emit('dataChange', null, beforeIimAccidentId);
      this.$emit('input', null);
      this.$emit('accidentName', null);
    },
    myRule(val) {
      if (this.required && !(val && val.length > 0)) {
        return ''
      }
    },
    linkClick(row) {
      this.$http.url = this.$format(selectConfig.sop.iim.accident.process.get.url, row);
      this.$http.type = "GET";
      this.$http.request((_result) => {
        this.popupOptions.title = "공정사고 상세"; 
        this.popupOptions.param = {
          iimAccidentId: row,
          stepCd: _result.data.accidentStatusCd || null,
          count: 0,
        };
        this.popupOptions.target = () => import(`${'@/pages/sop/iim/processAccidentDetail.vue'}`);
        this.popupOptions.isFull = true;
        this.popupOptions.visible = true;
        this.popupOptions.closeCallback = this.closePopup2;
      });
    },
    closePopup2() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
    },
  },
};
</script>
<style lang="sass">
.customAccident
  .q-field__native.row
    padding-left: 3px
    font-size: 0.95em
    padding-top: 4px !important
  .q-field__native
    padding-bottom: 6px !important
    cursor: pointer
  .q-field__label
    margin-left: 5px
  .material-icons
    font-size: 0.8rem
  .dateCloseIcon
    font-size: 0.8rem !important
    display: none
.customAccident:hover
  .dateCloseIcon
    display: block
.customAccident.q-field--dense .q-field__control, .customAccident.q-field--dense .q-field__marginal
  height: 33px !important
  min-height: 33px !important
.customAccident.q-field--filled .q-field__control
  border: 1px solid rgba(0,0,0,0.15) !important
  padding: 0px 8px 0px 2px
.customAccident.customTag.q-field--dense .q-field__control, .customAccident.customTag.q-field--dense .q-field__marginal
  height: min-content !important
  min-height: 33px !important
</style>
